import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'

const Section = styled.section`
  @media (min-width: 992px) {
    padding-top: 79px;
    padding-bottom: 102px;
  }

  @media (max-width: 991.98px) {
    padding-block: 3rem;
  }
`

const Title = styled.h2`
  color: ${(props) => props.theme.color.text.main};
  font-weight: 500;
  margin-bottom: 21px;

  @media (min-width: 992px) {
    font-size: 50px;
    line-height: 45px;
  }

  @media (max-width: 991.98px) {
    font-size: 32px;
    line-height: 32px;
  }
`

const Measure = styled.div`
  max-width: 781px;
  margin-inline: auto;
`

const Description = styled.div`
  font-size: 16px;
  line-height: 25px;

  & p {
    text-align: justify;
  }
`

function TextLinkLanding({ title, description }) {
  return (
    <Section>
      <div className="container">
        <Measure>
          {title && <Title>{title}</Title>}
          {description && (
            <Description>
              <ParseContent content={description} />
            </Description>
          )}
        </Measure>
      </div>
    </Section>
  )
}

export default TextLinkLanding
